module.exports = __webpack_public_path__ + "img/unifael-ser.87d8693f.png";